import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

export default class HelpDeskAlerts extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Calendar_Alerts._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.parent = this.state.calendars = this.props.parent;
	}

	render() {
		const {data, pages, loading} = this.state;
		const columns =
			[
				{
					Header: "Alerts",
					accessor: "alert_status",
					getProps: (headers, rowInfo) => {
						return {
							style: {
								background: rowInfo ? (rowInfo.original ? (rowInfo.original.alert_color ? rowInfo.original.alert_color : null) : null) : null,
							}
						}
					},
				}
			]
		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={7}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						showPagination={true}
						defaultPageSize={7}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
